import { render } from "./StaticRoutes.vue?vue&type=template&id=657e86f6&scoped=true"
import script from "./StaticRoutes.vue?vue&type=script&lang=js"
export * from "./StaticRoutes.vue?vue&type=script&lang=js"

import "./StaticRoutes.vue?vue&type=style&index=0&id=657e86f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657e86f6"]])

export default __exports__